<ng-container *ngIf="privacyPolicyUrl">
  <a id="acb-privacy-link" href="{{privacyPolicyUrl}}" target="_blank">ACB Privacy Policy</a>
  &nbsp; | &nbsp;
</ng-container>
<span class="acb-version">Version: {{env.appVersion}}</span>
